import _ from 'lodash';

import * as GladlyHelpApp from 'GladlyHelpApp';

// Whitelist of functions that should be exposed in our public facing API
const LIB_FUNCS = ['init', 'getAvailability', 'on', 'show'];

// Initial stub of the public API
const GladlyHelpAppsAPI = {
  init: config => {
    config.loaderCdn = GladlyHelpAppsAPI.loaderCdn;
    return new Promise((resolve, reject) => {
      GladlyHelpApp.init(config)
        .then(() => {
          delete GladlyHelpAppsAPI.loaderCdn;
          exposeAPIFunctions();
          resolve();
        })
        .catch(reject);
    });
  },
};

/**
 * Map the whitelisted API functions from GladlyHelpApps to the publicly exposed GladlyHelpAppsAPI
 * This is a way to control what functions we will give developer access to.
 */
const exposeAPIFunctions = () => {
  for (let func = LIB_FUNCS[0], i = 0; i < LIB_FUNCS.length; func = LIB_FUNCS[++i]) {
    GladlyHelpAppsAPI[func] = GladlyHelpApp[func];
  }
};

/**
 * Makes sure the real init functions gets called.
 *
 * There are three cases
 * 1. A developer want to have full controll when the help app is shown, they would them self
 *    call init() with the necessary parameters.
 * 2. A developer wants the help app to load automatically as soon as possible, instead of
 *    calling init() they would specify configuration on window.gladlyConfig
 * 3. The customer is using our old loader that does not create our API object that init() can
 *    be called on. Configuration is read from window.gladlyConfig
 */
let config = Object.assign({ autoShowWidget: true }, window.gladlyConfig);
if (window.__onHelpAppHostReady__) {
  window.__onHelpAppHostReady__(GladlyHelpAppsAPI);
  // If configuration is specified in window.gladlyConfig auto start chat
  if (window.gladlyConfig) {
    GladlyHelpAppsAPI.init(config);
  }
} else {
  // Script loader wasn't found, old loader is used
  GladlyHelpAppsAPI.init(config);
}
